
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.942 4.009a.91.91 0 01.916.903.897.897 0 01-.34.703 8.941 8.941 0 000 12.777c.208.168.34.42.34.705a.91.91 0 01-.916.903.92.92 0 01-.714-.336A10.682 10.682 0 011 12.004 10.73 10.73 0 014.222 4.34a.96.96 0 01.72-.33zM19.058 4a.92.92 0 01.719.342A10.711 10.711 0 0123 12.005a10.73 10.73 0 01-3.222 7.665.944.944 0 01-.674.285.91.91 0 01-.916-.904c0-.27.12-.514.312-.68a8.941 8.941 0 00-.018-12.755.93.93 0 01-.34-.713.91.91 0 01.916-.903zM7.508 6.584a.91.91 0 01.917.903.896.896 0 01-.316.682A5.378 5.378 0 006.5 12.005c0 1.496.616 2.852 1.61 3.833a.908.908 0 01.315.684.91.91 0 01-.917.903.92.92 0 01-.692-.311 7.153 7.153 0 01-.001-10.22c.169-.19.417-.31.693-.31zm8.984 0a.92.92 0 01.693.313 7.153 7.153 0 010 10.219.929.929 0 01-.693.31.91.91 0 01-.917-.904c0-.273.122-.517.316-.682a5.378 5.378 0 001.609-3.835 5.365 5.365 0 00-1.61-3.832.908.908 0 01-.315-.686.91.91 0 01.917-.903zM12 8.39c2.025 0 3.667 1.618 3.667 3.614 0 1.995-1.642 3.613-3.667 3.613S8.333 14 8.333 12.005c0-1.996 1.642-3.614 3.667-3.614z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    